import { PERMISSIONS } from 'constants/permissions';

export const ACCESS_PERMISSIONS = {
  COMPETITION: [PERMISSIONS.VIEW_COMPETITION],
  STRATEGY: [PERMISSIONS.UPDATE_CONTROL_INDICATOR],
};
